export default "__VITE_ASSET__Bh99YHJd__"